import React from 'react'
import ModalAgregarSucursal from './ModalAgregarSucursal'
import ModalDelete from '../../../../components/Modals/Generales/ModalDelete'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGUEstadoDocumentos} from '../../../../actions/action-creators'
import {State} from '../../../../reducers'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import ModalAgregarDocumento from './ModalAgregarDocumento'

const ModalsControls = () => {
  const {activeCrearEditar, activeCrearEditarDoc, activeEliminar, activeEstatus} = useSelector((state: State) => state.gestionUsuario.estadoDocumentos.modales)
  const {documentoSeleccionado} = useSelector((state: State) => state.gestionUsuario.estadoDocumentos)

  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionsGUEstadoDocumentos, dispatch)

  const cancelarEliminar = () => {
    dispatch(acciones.gu_ed_ShowModalEliminarDocumento(false))
    dispatch(acciones.gu_ed_ShowModalChangeEstatus(false))
    dispatch(acciones.gu_ed_SetDocumentoSeleccionado(null))
  }

  const handleDelete = () => {
    switch (documentoSeleccionado.title) {
      case 'sucursal':
        acciones.su_eliminarSucursal();
        break;
      case 'documento':
        acciones.su_eliminarDocumento();
        break;
        
    }
  }
  const handleChangeEstatus = () => {
    switch (documentoSeleccionado.title) {
      case 'sucursal':
        acciones.su_cambiarEstatusSucursal();
        break;
      case 'documento':
        acciones.su_cambiarEstatusDocumento();
        break;
    }
  }

  return (
    <>
      {activeCrearEditar && <ModalAgregarSucursal />}
      {activeCrearEditarDoc && <ModalAgregarDocumento />}
      {activeEliminar && (
        documentoSeleccionado.title === "sucursal" ? 
        (
          <ModalDelete
            title={`Eliminar sucursal`}
            detail='¿Seguro que quieres eliminar esta sucursal y sus documentos relacionados? Esta acción no se puede deshacer.'
            messageAction='Eliminar'
            actionDelete={handleDelete}
            closeModalDelete={cancelarEliminar}
            Styles={{minWidth: '25%', maxWidth: '650px'}}
          />
        )
        : 
        (
          <ModalDelete
            title={`Eliminar ${documentoSeleccionado?.title}`}
            detail='¿Seguro que quieres eliminar este documento? Esta acción no se puede deshacer.'
            messageAction='Eliminar'
            actionDelete={handleDelete}
            closeModalDelete={cancelarEliminar}
            Styles={{minWidth: '25%', maxWidth: '650px'}}
          />
        )
      )}
      {
        activeEstatus && 
        (
          <ModalConfirm 
            title={documentoSeleccionado?.accion ? `Activar ${documentoSeleccionado?.title}` : `Desactivar ${documentoSeleccionado?.title}`}
            detail={
              `¿Seguro que quieres realizar esta acción? 
              ${documentoSeleccionado?.title === "sucursal" 
                ? "Los documentos relacionados tambien serán afectados." : 
                ""
              }`
            }
            actionConfirm={handleChangeEstatus}
            closeModalConfirm={cancelarEliminar}
            />
        )
      }
    </>
  )
}

export default ModalsControls
